import { Host, h } from '@stencil/core';
export class PesRadioGroup {
  constructor() {
    this.value = undefined;
    this.text = undefined;
    this.name = undefined;
    this.checked = false;
  }
  onChange() {
    this.buttonChange.emit(this.value);
  }
  get id() {
    return `pes-radio-button-${this.name}-${this.value}`;
  }
  render() {
    return (h(Host, null, h("input", { onChange: () => this.onChange(), type: "radio", id: this.id, name: this.name, value: this.value, checked: this.checked }), h("label", { htmlFor: this.id }, this.text)));
  }
  static get is() { return "pes-radio-button"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["pes-radio-button.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["pes-radio-button.css"]
    };
  }
  static get properties() {
    return {
      "value": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "string | number",
          "resolved": "number | string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Radio button value."
        },
        "attribute": "value",
        "reflect": false
      },
      "text": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Radio button visible label."
        },
        "attribute": "text",
        "reflect": false
      },
      "name": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Radio button group id."
        },
        "attribute": "name",
        "reflect": false
      },
      "checked": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "if button selected."
        },
        "attribute": "checked",
        "reflect": false,
        "defaultValue": "false"
      }
    };
  }
  static get events() {
    return [{
        "method": "buttonChange",
        "name": "buttonChange",
        "bubbles": false,
        "cancelable": true,
        "composed": false,
        "docs": {
          "tags": [],
          "text": "Fired on pes-link click.\nContains page, pageId link parameters as event.detail."
        },
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        }
      }];
  }
}
